import { ScrollArea } from '@/components/ui/scroll-area';
import { Trophy, ExternalLink } from 'lucide-react';
import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SportsNewsSection = () => {
  const [sports, setSports] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSports = async () => {
      try {
        const response = await axios.get(`${API}/sports/news`);
        setSports(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching sports:', error);
        setLoading(false);
      }
    };
    fetchSports();
  }, []);

  return (
    <div className="content-card" data-testid="sports-section">
      <div className="card-header">
        <h2>
          <Trophy size={20} className="inline" /> Sports News
        </h2>
      </div>
      <ScrollArea className="card-content">
        {loading ? (
          <p className="loading-text">Loading sports...</p>
        ) : (
          <div className="news-list">
            {sports.length > 0 ? (
              sports.map((item, index) => (
                <div key={item.link || `${item.title}-${index}`} className="news-item" data-testid={`sports-${index}`}>
                  <h3 className="news-title">{item.title}</h3>
                  {item.summary && <p className="news-summary">{item.summary}</p>}
                  {item.link && (
                    <a 
                      href={item.link} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="news-link"
                    >
                      Read more <ExternalLink size={14} />
                    </a>
                  )}
                </div>
              ))
            ) : (
              <p className="no-data">No sports news available</p>
            )}
          </div>
        )}
      </ScrollArea>
    </div>
  );
};

export default SportsNewsSection;